import * as React from 'react';
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core/';
import { UserTypes } from 'core/auth/constants';

export default class Filters extends React.PureComponent<any> {
  render() {
    return (
      <FormControl component="fieldset">
        <FormLabel color="primary">Show selected user types</FormLabel>
        <FormGroup row>
          {Object.values(UserTypes).map((checkBoxItem: string) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.selectedUserTypes.includes(checkBoxItem)}
                  value={checkBoxItem}
                  color="default"
                  onChange={this.props.handleChange}
                />
              }
              key={checkBoxItem}
              label={checkBoxItem
                .charAt(0)
                .toUpperCase()
                .concat(checkBoxItem.slice(1))}
            />
          ))}
        </FormGroup>
      </FormControl>
    );
  }
}
